import React from 'react'
import styles from './AsideThumbBanner.styl'
import { object, func, bool } from 'prop-types'

export default class AsideThumbBanner extends React.Component {

	static propTypes = {
		service: object,
		changeStep: func,
		renderButton: bool
	}

	render() {
		const { service: { images, card, description }, changeStep, renderButton } = this.props
		return (
			<div>
				<div className={ styles['content'] }>
					<div className={ styles['image-container'] } style={ { backgroundImage: `url(${ images[0] })` } } />
					<div className={ styles['details-container'] }>
						<h2>{ card.title }</h2>
						<div dangerouslySetInnerHTML={ { __html: description } } />
						{ renderButton ? <div className={ styles['next-button'] } onClick={ changeStep }>Seguinte</div> : null }
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/components/AsideThumbBanner/AsideThumbBanner.js